import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import DefaultCounterCard from "examples/Cards/CounterCards/DefaultCounterCard";
import { useLanguage } from "context/LanguageContext";

function Featuring() {
  const { messages } = useLanguage();

  return (
    <MKBox component="section" py={10}>
      <Container>
        <Grid
          container
          item
          xs={12}
          lg={7}
          flexDirection="column"
          sx={{ mb: 6, mx: "auto", textAlign: "center" }}
        >
          <MKTypography variant="h2" mb={1}>
            {messages.constructionPage.stats.title}
          </MKTypography>
          <MKTypography variant="body1" color="text">
            {messages.constructionPage.stats.description}
          </MKTypography>
        </Grid>
        <Grid container justifyContent="center" sx={{ textAlign: "center" }}>
          {messages.constructionPage.stats.counters.map((counter) => (
            <Grid item xs={12} md={4} key={counter.title}>
              <DefaultCounterCard
                count={counter.count}
                suffix={counter.suffix}
                title={counter.title}
                description={counter.description}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Featuring;
